import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { RadioButtonGroupStyles } from "./RadioButtonGroup.styles";
export var RadioButtonsGroup = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, options = _a.options, onChange = _a.onChange;
    var sx = RadioButtonGroupStyles();
    var handleChange = function (event) {
        onChange(event.target.value);
    };
    return (_jsxs(FormControl, { children: [_jsx(FormLabel, { id: "rentio-".concat(id, "-radio-buttons-group-label"), sx: sx.content.formLabel, children: label }), _jsx(RadioGroup, { "aria-labelledby": "rentio-".concat(id, "-radio-buttons-group-label"), name: "rentio-".concat(id, "-radio-buttons-group"), value: value, onChange: handleChange, sx: sx.content.radioGroup, children: options.map(function (option) {
                    return (_jsx(FormControlLabel, { sx: sx.content.formControlLabel(option.value === value), value: option.value, control: _jsx(Radio, {}), label: option.label, checked: option.value === value }, option.value));
                }) })] }));
};
